import { render, staticRenderFns } from "./ProfileClave.vue?vue&type=template&id=7a479040"
import script from "./ProfileClave.vue?vue&type=script&lang=js"
export * from "./ProfileClave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports